const onReady = () => {
	
	const menu = document.querySelector('.sofimenu');

	const mouseenterHandle = (event) => {
		const item = event.target;
		const innerContainer = item.querySelector('.sofimenu__inner-container');

		if (
			innerContainer && 
			!innerContainer.classList.contains('sofimenu__inner-container--full')
		)
		{
			const menuRect = menu.getBoundingClientRect();
			const itemRect = item.getBoundingClientRect();
			const innerContainerRect = innerContainer.getBoundingClientRect();

			// if (innerContainerRect.width >= menuRect.width / 2)
			// {
			// 	if (innerContainerRect.width  < itemRect.left + itemRect.width - menuRect.left + 100)
			// 	{
			// 		innerContainer.style.right = 0;
			// 	}
			// 	else
			// 	{
			// 		innerContainer.style.left = 0;
			// 	}
			// }
			
			const left = itemRect.left + itemRect.width - menuRect.left - innerContainerRect.width / 2;
			if (left < 0)
			{
				innerContainer.style.left = 0;
				innerContainer.style.right = 'auto';
			}
			else if (menuRect.left + left + innerContainerRect.width > menuRect.left + menuRect.width)
			{
				innerContainer.style.right = 0;
				innerContainer.style.left = 'auto';
			}
			else
			{
				innerContainer.style.left = left + 'px'; 
				innerContainer.style.right = 'auto';
			}
			

		}
	};

	const mouseleaveHandle = (event) => {
		const item = event.target;
		const innerContainer = item.querySelector('.sofimenu__inner-container');

		if (
			innerContainer && 
			!innerContainer.classList.contains('sofimenu__inner-container--full')
		)
		{
			innerContainer.style.right = 'auto';
			innerContainer.style.left = 'auto';
		}
		
	}


	if (menu)
	{
		const menuItems = menu.querySelectorAll('.sofimenu__item');

		for (const item of menuItems)
		{
			item.addEventListener('mouseenter', mouseenterHandle);
			item.addEventListener('mouseleave', mouseleaveHandle);
		}
	}

}

document.addEventListener('DOMContentLoaded', onReady);